module.exports = "/hotel-booking/_next/static/images/logo-my-med-7ba39671a025c71e0ae255ac5cae713e.svg";